import { Text } from "@ui-kitten/components";
import Spacer from "components/Spacer";
import { TicketCartDetails } from "features/types";
import React from "react";
import { View } from "react-native";
import { formatCurrency } from "utils/appUtils";

const RefundDetails: React.FC<{ refundDetails: TicketCartDetails }> = (
  props
) => {
  const {
    refundDetails: {
      totalCreditCardCharges,
      totalCredits,
      totalPoints,
      priceType,
    },
  } = props;

  const noRefund =
    Number(totalCreditCardCharges) === 0 &&
    Number(totalCredits) === 0 &&
    Number(totalPoints) === 0;

  return (
    <View>
      <View className="self-end">
        <Text>Refund for Current Reservation:</Text>
        <Spacer margin={3} />
        <View className="self-end">
          {noRefund ? (
            <Text category="s1">N/A</Text>
          ) : (
            <View>
              {Number(totalCreditCardCharges) > 0 && (
                <Text category="s1">
                  {formatCurrency(totalCreditCardCharges)}
                  <Text> Credit Card</Text>
                </Text>
              )}
              {Number(totalCredits) > 0 && (
                <Text category="s1">
                  {formatCurrency(totalCredits)}
                  <Text> Account Credit</Text>
                </Text>
              )}
              {Number(totalPoints) > 0 && (
                <Text category="s1">
                  {formatCurrency(totalPoints, {
                    priceType,
                    showPoints: false,
                  })}
                  <Text> Bank Balance</Text>
                </Text>
              )}
            </View>
          )}
        </View>
      </View>
    </View>
  );
};

export default RefundDetails;
